import { computed } from "vue";
import { merge } from "lodash";
import { randomId } from "@/helpers/functions/randomId";

/** @returns {import("apexcharts").ApexOptions} */
const makedefaultOptions = (id = randomId("vue_chart")) => ({
  chart: {
    id,
    toolbar: {
      show: false,
    },
    width: "100%",
    stacked: true,
  },
  plotOptions: {
    bar: {
      horizontal: true,
      distributed: true,
      columnWidth: "55%",
    },
  },
  grid: {
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  yaxis: {
    labels: {
      align: "left",
      offsetX: -12,
    },
  },
  colors: ["#216eff", "#5603ad", "#225373", "#1F9651"],
  stroke: {
    curve: "smooth",
  },
});

/**
 * Combina as opções padrão do ApexCharts com overrides reativos.
 *
 * @param {import("vue").ComputedRef<import("apexcharts").ApexOptions>} chartOptions
 * @returns {{ options: import("vue").ComputedRef<import("apexcharts").ApexOptions> }}
 */
export function useApexCharts(chartOptions) {
  const options = computed(() =>
    merge({}, makedefaultOptions(), chartOptions.value)
  );

  return { options };
}
